import React from 'react';
import HomeIcon from '../common/HomeIcon';
import {NavLink} from 'react-router-dom';

class Mantra29_A1 extends React.Component {
    constructor() {
        super();
      
    }
    
    render() {
        return (
            <>
           <HomeIcon />
                <div className="m3_a1_container">
                          
                            <div className="container">
                                <div className="pos_rel">
                                    <img src="/assets/img/Mantra_29.jpg" className="m3a1_img" />

                                </div>
                                <div className="mantra_18_btns">
                                    <NavLink to={'/mantra29_a1_edit'}>
                                    <button  className="btn_f">Fill & Share</button>
                                    </NavLink>
                                    <h5 className="or">Or</h5>
                                   
                                        <button className="btn_f">Download</button>
                                  
                                </div>
                            </div>
                        </div>
              

            </>
        )
    }
}

export default Mantra29_A1;